// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Wishlist_fullWidth__SGtiC","hidden":"Wishlist_hidden__YuiWm"};